import allCitiesJson from './data.json';

const allCities = allCitiesJson.map(city => city.domain);

export const getCityFromHostName = (hostname?: string): string => {
    if (!hostname) {
        return '';
    }

    return allCities.find(city => hostname.startsWith(city)) || '';
};
